import React, { Component } from 'react'
import CheckLoginStatus from "../../conditions/CheckLoginStatus";
import AuthLayout from "../../layouts/AuthLayout";
import { action, observable } from 'mobx'
import { observer } from 'mobx-react'
import Card from "../../components/Card";
import request from "../../utils/request";
import Input from "../../components/Input";
import Button from "../../components/Button";
import styled from 'styled-components'
import Link from '../../components/Link'

const LinkBox = styled.div`
  display: flex;
  justify-content: space-between;
`
@observer
export class ExternalLogin extends Component {
  @observable error = false
  @observable loading = false

  @observable
  fields = {
    email: '',
    password: '',
  }

  @action
  setField = event => {
    this.error = false
    this.fields[event.target.name] = event.target.value
  }

  @action
  setLoading = () => {
    this.loading = true
    this.error = false
  }

  @action
  setError = () => {
    this.loading = false
    this.error = true
  }
  submit = async event => {
    event.preventDefault()
    this.setLoading()
    const res = await request('/api/auth/external', this.fields)

    if (res.success) {
      window.location = '/dashboard'
    } else {
      this.setError()
    }
  }

  render() {
    return (
      <CheckLoginStatus loggedInRedirect="/dashboard">
        <AuthLayout>
          <h1>External Login</h1>
          <Card>
            {this.error && <Card.ErrorMessage />}
            <form onSubmit={this.submit}>
              <Card.Pad>
                <Input
                  disabled={this.loading}
                  label="titles.email"
                  name="email"
                  value={this.fields.email}
                  onChange={this.setField}
                />
                <Input
                  disabled={this.loading}
                  label="titles.password"
                  name="password"
                  type="password"
                  value={this.fields.password}
                  onChange={this.setField}
                />
                <LinkBox>
                  <div>&nbsp;</div>
                  <Link str="titles.signUp" to="/sign-up"/>
                </LinkBox>
              </Card.Pad>
              <Card.Divider />
              <Card.Pad>
                <Button
                  str="titles.signIn"
                  color="blue"
                  type="submit"
                />
              </Card.Pad>
            </form>
          </Card>
        </AuthLayout>
      </CheckLoginStatus>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/ExternalLogin/index.js